import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import { Dialog, DialogContent, IconButton, Stack } from "@mui/material";
import Button from "@mui/material/Button"; // Import Button
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import DataTable from "common/Tables/DataTable";
import mistakesTableData from "layouts/tables/data/mistakesTableData";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDealers } from "store/slice/dealersSlice";
import { useNavigate, useLocation } from "react-router-dom";
import { getStudios } from "store/slice/studiosSlice";
import { getUserMistakes } from "store/slice/mistakesSlice";
import CloseIcon from "@mui/icons-material/Close";
import { deleteDealer } from "store/slice/dealersSlice";
import { deleteDealerMistake } from "store/slice/mistakesSlice";
import MistakesFilters from "./MistakesFilters";
import { getUserDefaults } from "store/slice/mistakesSlice";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { exportMistake } from "store/slice/mistakesSlice";

function DealersMistakes() {
  const mistakesStore = useSelector((store) => store.mistakes);
  const usersStore = useSelector((store) => store.user);
  const currentUser = usersStore.user;

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [modalImage, setModalImage] = useState(null);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(25);
  const total = useSelector((store) => store.mistakes.total);

  useEffect(() => {
    dispatch(getUserDefaults());
  }, []);

  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
    dealer: "all",
    studio: "all",
    mistake: "all",
    status: "APPROVED",
  });

  const handleSetFilters = useCallback((updater) => {
    setFilters(updater);
    setPage(0);
  }, []);

  useEffect(() => {
    dispatch(getUserMistakes({ ...filters, page: page + 1, limit }));
  }, [filters, page, limit, location.key]);

  const editAction = (game) => {
    navigate(`/dealersMisatke/${game.id}`);
  };

  const handleImageClick = useCallback((imageUrl) => {
    setModalImage(imageUrl);
  }, []);

  const handleDeleteAction = useCallback((mistake) => {
    dispatch(deleteDealerMistake(mistake.id));
  }, [dispatch]);

  const { columns, rows } = useMemo(() => mistakesTableData({
    mistakes: mistakesStore.mistakes,
    user: currentUser,
    onImageClick: handleImageClick,
    deleteAction: handleDeleteAction,
  }), [mistakesStore.mistakes, currentUser, handleImageClick, handleDeleteAction]);

  useEffect(() => {
    dispatch(getStudios());
  }, []);

  const handleAddGame = () => {
    navigate("/dealersMistakes/new");
  };
  const mistakesLIst = useMemo(() =>
    Object.entries(mistakesStore?.mistakesListData ?? {}).map(([key, value]) => ({ key, name: value })),
  [mistakesStore.mistakesListData]);
  
  const handleExport = () => {
    dispatch(exportMistake(filters))
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item size={{ xs: 12 }}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Mistakes
                </MDTypography>
                <Stack direction="row" spacing={2}>
                  <Button
                      variant="outlined"
                      onClick={(handleExport)}
                      startIcon={<FileDownloadIcon />}
                      sx={{
                        color: "white !important",
                        borderColor: "white !important",
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": { borderColor: "#f0f0f0", backgroundColor: "rgba(255,255,255,0.1)" }
                      }}
                    >
                      Export
                    </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAddGame} // Add click handler
                  >
                    Add Misatake
                  </Button>
                </Stack>
              </MDBox>
                <MistakesFilters
                  filters={filters}
                  setFilters={handleSetFilters}
                  dealers={mistakesStore.dealers || []}
                  studios={mistakesStore.studios || []}
                  mistakesList={mistakesLIst || []}
                />
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  showTotalEntries={false}
                  entriesPerPage={{ defaultValue: limit, entries: [10, 25, 50, 100] }}
                  noEndBorder
                  manualPagination
                  pageCount={Math.ceil(total / limit)}
                  currentPage={page}
                  onPageChange={setPage}
                  onPageSizeChange={(newLimit) => { setLimit(newLimit); setPage(0); }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog
        open={Boolean(modalImage)}
        onClose={() => setModalImage(null)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
            padding: 0,
            backgroundColor: "#fff",
          },
        }}
      >
        <DialogContent
          style={{
            position: "relative",
            padding: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#fff",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={() => setModalImage(null)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.5)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.7)" },
            }}
          >
            <CloseIcon />
          </IconButton>
          {modalImage && (
            <img
              src={modalImage}
              alt="Full Size"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "90vh",
                objectFit: "contain",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </DashboardLayout>
  );
}

export default DealersMistakes;
